export default "__VITE_ASSET__DtDdUbWC__"